import React  from 'react'
import { GetFolios } from '../../../api/services/finance';
import DropDown from '../dropdown';
import {EntityTypes} from '../constants'

const FoliosDropDown = ({...props}) => {
    return <DropDown api={GetFolios} textField={value=>value.Owner.Name} descriptionField={value=>EntityTypes[value.Owner.EntityTypeId]} labelField="Id" valueField="Id"  {...props}/>
}

export default FoliosDropDown